import React, { ChangeEvent, ChangeEventHandler } from "react";

import { Button } from "@chainsafe/common-components";
import { Input } from "@chakra-ui/input";
import { Tokens } from "@chainsafe/web3-context/dist/context/tokensReducer";
import { UseFormRegister } from "react-hook-form";

interface ITokenInput {
  name: string;
  value: string;
  isDisabled: boolean;
  placeholder: string;
  tokens: Tokens;
  tokenSelectorKey: string;
  classNames?: {
    input?: string;
    button?: string;
  };
  onChange: (value: string) => void;
  register: UseFormRegister<any>;
}

const TokenInput: React.FC<ITokenInput> = ({
  name,
  value,
  isDisabled,
  placeholder,
  tokens,
  tokenSelectorKey,
  onChange,
  register,
}: ITokenInput) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const tokenAmountValidator = register(name);
  return (
    <>
      <Input
        borderRadius="0px"
        name={name}
        isDisabled={isDisabled}
        placeholder={placeholder}
        onChange={(e) => {
          tokenAmountValidator.onChange(e); // form validation
          onChange(e.target.value); // data passing
        }}
        onBlur={tokenAmountValidator.onBlur}
        ref={tokenAmountValidator.ref}
        value={value}
      />
      {/* <Button
        disabled={
          disabled || !tokens[(values as Record<string, any>)[tokenSelectorKey]]
        }
        className={classNames?.button}
        onClick={() => {
          setValue(
            tokens[(values as Record<string, any>)[tokenSelectorKey]].balance
          );
        }}
        variant="outline"
        type="button"
      >
        MAX
      </Button> */}
    </>
  );
};

export default TokenInput;
